/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import ClassicProjectFieldsAppQuery, {
	type ClassicProjectFieldsAppQuery as ClassicProjectFieldsAppQueryType,
} from './__generated__/ClassicProjectFieldsAppQuery.graphql';

type Queries = {
	pageQueryRef: ClassicProjectFieldsAppQueryType;
};

type ClassicProjectFieldsEntryPointComponent = EntryPointComponent<Queries, {}, {}, {}>;

export const classicProjectFieldsEntryPoint: EntryPoint<
	ClassicProjectFieldsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<ClassicProjectFieldsEntryPointComponent>(
		/* webpackChunkName: "async-jira-project-settings-classic-project-fields" */ './ClassicProjectFieldsApp.tsx',
	),
	getPreloadProps: ({ context, tenantContext }: EntryPointRouteParams) => {
		const { projectKey } = context.match.params;

		if (!projectKey) {
			throw new Error('Project key is required for classic project fields page');
		}

		return {
			queries: {
				pageQueryRef: {
					parameters: ClassicProjectFieldsAppQuery,
					variables: {
						cloudId: tenantContext.cloudId,
						projectKey,
						availableOnInput: {
							schemeOrProject: {
								projectKey,
							},
						},
						descriptionsInput: {
							schemeOrProject: {
								projectKey,
							},
						},
						requiredOnInput: {
							schemeOrProject: {
								projectKey,
							},
						},
					},
					options: {
						fetchPolicy: 'network-only' as const,
					},
				},
			},
		};
	},
});
